import { Component, Input, OnInit } from '@angular/core';
import { PageEvent } from '@angular/material/paginator';
import { Lightbox } from 'ngx-lightbox';
import { ContestWinnerModel } from '../../models/contestWinner.model';

@Component({
  selector: 'winners-gallery',
  templateUrl: './winners-gallery.component.html',
  styleUrls: ['./winners-gallery.component.css']
})
export class WinnersGalleryComponent implements OnInit {

  @Input('contestWinners') contestWinners : ContestWinnerModel[];
  @Input() gradeCategoryName: any;
  
  constructor(private _lightbox: Lightbox) {
  }

  ngOnInit() {
    
  }

  open(item): void {
    let items: Array<any> = [{ src: item.pictureName, thumb: item.pictureThumbName }];
    this._lightbox.open(items, 0);
  }

  close(): void {
    this._lightbox.close();
  }
}
